<template>
  <a class="project"
     :class="{ 'focus': focus }"
     rel="nofollow noopener"
     target="_blank"
     :href="project.link"
  >
      <img
        :data-src="project.image"
        :alt="project.name"
        class="lazyload"
      >

      <div class="name">
        <h3 v-text="project.name"></h3>
      </div>
  </a>
</template>

<script>
export default {
  props: {
    project: {
      type: Object
    },
    position: {
      type: Number
    }
  },

  data() {
    return {
      focus: false
    };
  },

  created() {
    this.focusProject();
  },

  methods: {
    focusProject() {
      setTimeout(() => {
        this.focus = true;
        setTimeout(() => {
          this.focus = false;
        }, 500);
      }, this.position * 500);
    }
  }
};
</script>

<style>
.project {
  display: block;
  background: #000;
  flex-basis: 32%;
  margin-bottom: 20px;
  height: 135px;
  position: relative;
}

@media all and (max-width: 1240px) {
  .project {
    flex-basis: 48%;
  }
}

@media all and (max-width: 460px) {
  .project {
    flex-basis: 100%;
  }
}

.project img {
  position: absolute;
  z-index: 8;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  opacity: 0.5;
}

.project:hover img,
.project.focus img {
  opacity: 0.6;
}

.project .name {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.project .name h3 {
  color: white;
  font-size: 1.6em;
}
</style>
